<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Select Project</p>
    </header>
    <section class="modal-card-body">
      <b-table
        :columns="columns"
        :data="tableData"
        focusable
        :selected.sync="selected"
        paginated
        :per-page="20"
        :current-page.sync="currentPage"
      ></b-table>
    </section>
    <footer class="modal-card-foot">
      <b-button @click="$parent.close()">Close</b-button>
      <b-button @click="onClickSelect" type="is-primary" :disabled="disabled"
        >Select</b-button
      >
    </footer>
  </div>
</template>


<script>
import { ref, onMounted, computed } from "@vue/composition-api";
import useWarnings from "@/composables/useWarnings";
import isEmpty from "lodash/isEmpty";
import ui from "@/store/modules/ui";
import $axios from "@/axios-instance";
import { SnackbarProgrammatic as Snackbar } from "buefy";
import annotations from "../store/modules/annotations";

export default {
  props: {
    syncPage: Function
  },
  setup(props, { parent }) {
    // table columns
    const columns = [
      {
        field: "name",
        label: "Name"
      }
    ];

    // table data
    const projectList = ref([]);
    const tableData = computed(() => {
      return projectList.value.map(name => ({
        name
      }));
    });

    // datas
    const selected = ref({});
    const currentPage = ref(1);
    const disabled = computed(() => {
      if (isEmpty(selected.value)) {
        return true;
      } else {
        return false;
      }
    });
    // events
    const { shouldProceed } = useWarnings();
    const onClickSelect = async () => {
      // Check for unsaved changes
      if (!shouldProceed()) return;
      // Close modal
      parent.close();
      // Start loading
      ui.setIsLoadingAnnotation(true);
      try {
        // Reset local annotations
        annotations.resetLocal();
        // Unselect floorplan
        await ui.unselectFloorplan();
        // Switch Project
        await ui.syncSelectedProject(selected.value.name);
        // Reset table to page 1
        props.syncPage(1);
      } catch (err) {
        console.error(
          "onClickSelect in ProjectSelectorAdmin failed: " + err.message
        );
        Snackbar.open({
          message: "Server Access Failed",
          actionText: "Close",
          type: "is-warning",
          indefinite: true,
          position: "is-top"
        });
      } finally {
        // Stop loading
        ui.setIsLoadingAnnotation(false);
      }
    };
    // hook
    onMounted(async () => {
      const result = await $axios.get("/projects");
      if (result.data.success) {
        projectList.value = result.data.payload;
      }
    });
    return {
      columns,
      tableData,
      disabled,
      selected,
      currentPage,
      onClickSelect
    };
  }
};
</script>
